// extracted by mini-css-extract-plugin
module.exports = {"author-wrapper":"_2HcFm","time-ago":"_2p9ED"};